import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { DICT } from "@/lib/i18n";

const LANG_KEY = "lp_lang";
const LangContext = createContext({ lang: "it", t: DICT.it, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => (localStorage.getItem(LANG_KEY) === "en" ? "en" : "it"));

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    localStorage.setItem(LANG_KEY, l);
    setLangState(l);
  }, []);

  return <LangContext.Provider value={{ lang, t: DICT[lang], setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
